import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Table,
  Toast,
  ToastBody,
  ToastHeader,
} from "reactstrap";
import { MapContainer, TileLayer } from "react-leaflet";
import "./style/index.scss";
import placeHolder from "../../../assets/images/placeHolder.png";
import { TitleBar } from "../../../Components/Common/TitleBar/titleBar";
import { useParams } from "react-router-dom";
import { getTripsById } from "../../../slices/thunks";
import { useDispatch, useSelector } from "react-redux";
import { hideErrorMessage } from "../../../slices/tripsDetails/reducer";

const tripDetails = [
  { label: "Trip ID", value: "100" },
  { label: "Driver name", value: "100" },
  { label: "Truck number", value: "100" },
  { label: "Position", value: "100" },
  { label: "Date", value: "10-00-00" },
  { label: "Customer name", value: "100" },
  { label: "Vehicle type", value: "100" },
  { label: "Distance (km)", value: "100" },
];

const tripItinerary = [
  { event: "Row", date: "Row", hours: "Row" },
  { event: "Row", date: "Row", hours: "Row" },
  { event: "Row", date: "Row", hours: "Row" },
  { event: "Row", date: "Row", hours: "Row" },
  { event: "Row", date: "Row", hours: "Row" },
];

const TripDetail = () => {
  const { id } = useParams();

  const dispatch = useDispatch();

  const tripsById = useSelector((state) => state.Trips.tripsById);
  const error = useSelector((state) => state.Trips.error);
  const errorMessage = useSelector((state) => state.Trips.errorMessage);

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    try {
      if (id) {
        dispatch(getTripsById(id));
      }

      if (error && errorMessage) {
        setShowToast(true);
        setToastMessage(errorMessage);
        setTimeout(() => {
          setShowToast(false);
          dispatch(hideErrorMessage());
        }, 3000);
      }
    } catch (error) { }
  }, [id, error, errorMessage]);

  document.title = "Trip Detail | D&A";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex flex-column gap-4">
            <TitleBar title={"Trip detail"} showIcon={true} />

            <div
              className="position-fixed top-0 end-0 p-3"
              style={{ zIndex: 1055 }}
            >
              <Toast isOpen={showToast}>
                <ToastHeader
                  icon={error ? "danger" : "success"}
                  toggle={() => setShowToast(false)}
                >
                  {error ? "Error" : "Success"}
                </ToastHeader>
                <ToastBody>{toastMessage}</ToastBody>
              </Toast>
            </div>

            <Row>
              <Col md={5}>
                <Card className="realTimeTripCard">
                  <CardBody>
                    <MapContainer
                      center={[45.4654, 9.1859]}
                      zoom={7}
                      style={{ height: "683px", width: "100%" }}
                    >
                      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    </MapContainer>
                  </CardBody>
                </Card>
              </Col>
              <Col md={7}>
                <div className="d-flex flex-column gap-4">
                  <Row className="gy-3 mt-1">
                    {tripDetails.map((ele, index) => {
                      return (
                        <Col
                          md={3}
                          sm={6}
                          key={index}
                          className="detailCardWrap"
                        >
                          <div className="detailCard">
                            <span className="idText">{ele.label}</span>
                            <p className="tripId">{ele.value}</p>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                  <div>
                    <div className="tripTitleBar">TRIP ITINERARY</div>
                    <Table className="m-0">
                      <thead>
                        <tr>
                          <th className="tripTabHeader">Event</th>
                          <th className="tripTabHeader">Date</th>
                          <th className="tripTabHeader">Hours</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tripItinerary.map((row, index) => (
                          <tr key={index}>
                            <td className="tripTabContent">{row.event}</td>
                            <td className="tripTabContent">{row.date}</td>
                            <td className="tripTabContent">{row.hours}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  <div>
                    <div className="tripTitleBar">
                      PHOTO LOADING / DOWNLOADING
                    </div>
                    <div className="mt-2 d-flex gap-3">
                      {[...Array(4)].map((_, i) => {
                        return <img key={i} src={placeHolder} />;
                      })}
                    </div>
                  </div>
                  <div>
                    <div className="tripTitleBar">REFUELING CARDS</div>
                    <div className="mt-2 d-flex gap-3">
                      {[...Array(4)].map((_, i) => {
                        return <img key={i} src={placeHolder} />;
                      })}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TripDetail;
